var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CurriculaService } from 'app/services';
var CvPreviewComponent = /** @class */ (function () {
    function CvPreviewComponent(curriculaService, sanitizer) {
        this.curriculaService = curriculaService;
        this.sanitizer = sanitizer;
        this.applicationId = null;
        this.isModalExpanded = false;
        this.onClick = new EventEmitter();
        this.imgs = [];
    }
    CvPreviewComponent.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var arr, i, p, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.imgs = [];
                        arr = [];
                        return [4 /*yield*/, new Promise(function (resolve) { setTimeout(function () { resolve(true); }, 100); })];
                    case 1:
                        _a.sent();
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < this.pages)) return [3 /*break*/, 7];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.curriculaService.getCurriculaPage(this.applicationId, i).toPromise()];
                    case 4:
                        p = _a.sent();
                        // arr.push(this.curriculaService.getCurriculaPage(this.applicationId, i).toPromise())
                        // this.imgs.push(this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([p.body], { type: 'image/jpeg' }))));
                        this.imgs[i] = (this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([p.body], { type: 'image/jpeg' }))));
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        i++;
                        return [3 /*break*/, 2];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CvPreviewComponent.prototype.ngOnChanges = function (changes) {
        console.log(changes);
        if (changes && (changes.applicationId || (changes.isModalExpanded && (changes.isModalExpanded.currentValue === null)))) {
            this.init();
        }
    };
    CvPreviewComponent.prototype.ngOnDestroy = function () {
        this.imgs = [];
    };
    return CvPreviewComponent;
}());
export { CvPreviewComponent };
